<template>
    <div id="read">
        <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>常见问题设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card class="box-card">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="问题分类" name="problemClass">
                    <problemClass v-if="activeName=='problemClass'"></problemClass>
                </el-tab-pane>
                <el-tab-pane label="问题列表" name="problemList">
                    <problemList v-if="activeName=='problemList'"></problemList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
  import problemClass from '../../components/problem/problemClass' //福利中心设置
  import problemList from '../../components/problem/problemList' //幸运大转盘
  export default {
    name: "read",
    components: {problemClass, problemList},
    data() {
      return {
        activeName: 'problemClass'
      }
    },
    created() {
      // this.getData()
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name
      },
    }
  }
</script>

<style scoped>

</style>